<ng-container *transloco="let t">
  <div>
    <form nz-form [formGroup]="contactForm">
      <nz-form-item class="lg:flex">
        <nz-form-label
          class="w-3/12 md:w-4/12 lg:w-1/4"
          nzRequired
          nzFor="name">
          {{ t('agents.addEdit.fields.name') }}
        </nz-form-label>
        <nz-form-control [nzErrorTip]="nameCheck">
          <input
            type="text"
            nz-input
            class="w-full"
            formControlName="name"
            [placeholder]="t('agents.addEdit.placeholders.contactName')" />
        </nz-form-control>
        <ng-template #nameCheck>
          <span *ngIf="formErrors.name.required">
            {{ t('agents.addEdit.errors.contactNameRequired') }}
          </span>
        </ng-template>
      </nz-form-item>

      <nz-form-item class="lg:flex">
        <nz-form-label
          class="w-3/12 md:w-4/12 lg:w-1/4"
          nzFor="email">
          {{ t('agents.addEdit.fields.email') }}
        </nz-form-label>
        <nz-form-control [nzErrorTip]="emailCheck">
          <input
            type="text"
            nz-input
            class="w-full"
            formControlName="email"
            [placeholder]="t('agents.addEdit.placeholders.contactEmail')" />
        </nz-form-control>
        <ng-template #emailCheck>
          <span *ngIf="formErrors.email.email">
            {{ t('agents.addEdit.errors.contactEmailInvalid') }}
          </span>
        </ng-template>
      </nz-form-item>

      <nz-form-item class="lg:flex">
        <nz-form-label
          class="w-3/12 md:w-4/12 lg:w-1/4"
          nzFor="contactNo">
          {{ t('agents.addEdit.fields.contactNo') }}
        </nz-form-label>
        <nz-form-control [nzErrorTip]="contactNumberCheck">
          <nz-input-group [nzAddOnBefore]="selectBefore">
            <ng-template #selectBefore>
              <nz-select
                nzAllowClear
                nzShowSearch
                [nzPlaceHolder]="t('agents.addEdit.placeholders.dialCode')"
                formControlName="dialCode"
                style="width: 100px"
                [nzDropdownStyle]="{ width: '250px' }">
                <nz-option
                  *ngFor="let data of countries"
                  [nzValue]="data.dialing_code"
                  nzCustomContent="true"
                  [nzLabel]="data.dialing_code + ' ' + data.name">
                  <div class="flex">
                    <img [src]="data.image" width="20" height="20" alt="country" />
                    <span class="mx-2">{{ data.name }}</span>
                    <span>{{ data.dialing_code }}</span>
                  </div>
                </nz-option>
              </nz-select>
            </ng-template>

            <input
              nz-input
              formControlName="contactNo"
              [placeholder]="t('agents.addEdit.placeholders.contactNumber')" />
          </nz-input-group>

          <ng-template #contactNumberCheck>
            <span *ngIf="formErrors.contactNo.pattern">
              {{ t('agents.addEdit.errors.contactNumberInvalid') }}
            </span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>

    <div class="mb-5">
      <div class="flex justify-end">
        <ng-container *ngIf="mode !== 'edit'; else editMode">
          <button
            *appHasAnyPrivilege="'AGENT.CONTACT.ADD'"
            nz-button
            nzType="primary"
            [disabled]="contactForm.invalid || isSubmitting"
            (click)="addNewContact()">
            {{ t('agents.addEdit.buttons.addContact') }}
          </button>
        </ng-container>

        <ng-template #editMode>
          <button
            *appHasAnyPrivilege="'AGENT.CONTACT.EDIT'"
            nz-button
            nzType="primary"
            [disabled]="contactForm.invalid || isSubmitting"
            (click)="editContact()">
            {{ t('agents.addEdit.buttons.updateContact') }}
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>